import tw from 'twin.macro';
import { UpperPartWrap } from '../signInvigilatorRecords/styles';

export const PageWrapper = tw.div`mx-auto
 flex flex-col h-screen relative pt-12`;

export const H5 = tw.h5`mr-60 ml-14 hover:text-blue-600
 hover:border-blue-600 border-b border-gray-50 pb-1
 2xl:mr-80 2xl:ml-24 cursor-pointer  text-gray-600`;

export const CusUpperPart = tw(UpperPartWrap)`items-center`;

export const Tableheader = tw.div`flex items-center justify-between mb-8 mt-16`;

export const Tabletitle = tw.h2`text-center mx-auto text-xl font-semibold `;

export const SelectExamsType = tw.select`bg-gray-100 mr-10 p-2 rounded-lg`;

export const SelectOption = tw.option`text-base font-normal`;

export const Table = tw.div`w-full pb-8`;

export const Thead = tw.div`grid grid-cols-16 gap-2 py-3 bg-white px-1.5 font-medium text-base`;

export const ColSpan1 = tw.div`col-span-1 text-center`;

export const ColSpan2 = tw.div`col-span-2`;

export const ColSpan4 = tw.div`col-span-4`;

export const Payroll = tw.h6`text-red-600! uppercase`;

export const Cash = tw.h6`text-green-600 uppercase`;

export const Tablerow = tw.div`bg-gray-100 grid items-center
 grid-cols-16 font-semibold text-sm 2xl:text-base rounded-lg mt-4 py-3 gap-2  px-1.5`;
